export {}

const eventsWFilterSections = document.querySelectorAll<HTMLElement>('.s-events-w-filter');

eventsWFilterSections.forEach(section => {
  const responseSettings = {
    method: "POST",
  }
  const filter = section.querySelector<HTMLElement>('.i-filter')
  const events = section.querySelector<HTMLElement>('.g-events')

  if (!filter || !events) return;

  filter.addEventListener('filter', async () => {
    events.classList.add('--loading');

    const response = await fetch('/events/filter', responseSettings)

    if (!response.ok) {
      events.classList.remove("--loading")

      return;
    }
  })
})
